import { Component, input } from '@angular/core';

@Component({
  selector: 'app-icon-minus',
  templateUrl: './icon-minus.component.html',
  styleUrls: ['./icon-minus.component.scss'],
})
export class IconMinusComponent {
  width = input<string>('20px');
  height = input<string>('21px');
  color = input<string>('#fff');
}
